// extracted by mini-css-extract-plugin
export var main = "styles-module--main--385SH";
export var content = "styles-module--content--2szCM";